import { apiFactory } from '@app/client/apiFactory/api';
import { Request } from '@app/client/common/api/requests';
import { type ApiResult, type BaseParams, type EditionsType } from '@app/client/common/structs';
import { links } from '@app/client/links';

function requestEditions(params: BaseParams): Promise<ApiResult<EditionsType>> {
    return Request.getRequest<EditionsType>({
        ...params,
        target: links.editions(),
    });
}

// TODO: Should this be `async`?
export function getEmojiEditions(params: BaseParams = {}): Promise<EditionsType> {
    return apiFactory()
        .call(requestEditions, params)
        .then((result) => {
            if (result.ok) return result.value;

            const errorMessage = result?.error?.detail ?? 'Error retrieving emoji editions.';
            throw new Error(errorMessage);
        });
}
